import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from '@flex-design-system/ve-presets';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { forwardRef, useState } from 'react';
import { SegmentedControlIndicator } from './components/indicator/Indicator.mjs';
import { SegmentedControlItemSlot } from './components/item-slot/ItemSlot.mjs';
import { SegmentedControlItem } from './components/item/Item.mjs';
import { useSyncIndicatorToActiveItem } from './hooks/useSyncIndicatorToActiveItem.mjs';
import { segmentedControl } from './segmentedControl.vanilla.mjs';

const SegmentedControlImpl = forwardRef(
  ({
    children,
    className: classNameFromProps,
    fullWidth,
    prefersReducedMotion,
    size,
    value: valueFromProps,
    defaultValue: defaultValueFromProps,
    onValueChange,
    ...props
  }, forwardedRef) => {
    const [segmentedControlElement, setSegmentedControlElement] = useState(null);
    const [
      segmentedControlIndicatorElement,
      setSegmentedControlIndicatorElement
    ] = useState(null);
    const [value, setValue] = useControllableState({
      prop: valueFromProps,
      defaultProp: defaultValueFromProps,
      onChange: onValueChange
    });
    const composedRef = useComposedRefs(
      forwardedRef,
      setSegmentedControlElement
    );
    const className = clsx(
      segmentedControl({ fullWidth, size }),
      classNameFromProps
    );
    useSyncIndicatorToActiveItem({
      indicatorElement: segmentedControlIndicatorElement,
      rootElement: segmentedControlElement,
      value
    });
    return /* @__PURE__ */ jsxs(
      RadioGroupPrimitive.Root,
      {
        "data-scope": "segmented-control",
        "data-part": "root",
        className,
        orientation: "horizontal",
        value,
        onValueChange: setValue,
        ref: composedRef,
        ...props,
        children: [
          children,
          /* @__PURE__ */ jsx(
            SegmentedControlIndicator,
            {
              prefersReducedMotion,
              ref: setSegmentedControlIndicatorElement
            }
          )
        ]
      }
    );
  }
);
const SegmentedControl = Object.assign({}, SegmentedControlImpl, {
  Item: SegmentedControlItem,
  ItemSlot: SegmentedControlItemSlot
});
SegmentedControl.displayName = "SegmentedControl";

export { SegmentedControl };
//# sourceMappingURL=SegmentedControl.mjs.map
